export const setupData = {
  requiredFieldMsg: 'This field is required',
  systemErrorMsg: 'There was an error. Please try again later',
  images: {
    trr: 'https://iprofstore.blob.core.windows.net/secureforms/roofrealty.png',
    iso: 'https://iprofstore.blob.core.windows.net/secureforms/iso.png',
    jas: '	https://iprofstore.blob.core.windows.net/secureforms/jas.png',
    hartaTanah: 'https://iprofstore.blob.core.windows.net/secureforms/EjenHartaTanah.png',
  },
  identityType: [
    {label: 'NRIC No', value: 'NRIC'},
    {label: 'Passport No', value: 'Passport No'},
    {label: 'Co Reg No', value: 'Co Reg No'},
  ],
  agencyIdentityType: [
    {label: 'NRIC No', value: 'NRIC'},
    {label: 'Passport No', value: 'Passport No'},
  ],
  earnDepositType: [
    {label: 'Select One ....', value: ''},
    {label: 'By Percentage', value: '%'},
    {label: 'By Amount', value: 'RM'},
  ],
  downpaymentType: [
    {label: 'Select One ....', value: ''},
    {label: 'By Percentage', value: '%'},
    {label: 'By Amount', value: 'RM'},
  ],
  commissionType: [
    {label: 'Select One ....', value: ''},
    {label: 'By Percentage', value: '%'},
    {label: 'By Amount', value: 'RM'},
  ],
  yearMonthType: ['Year', 'Month'],
  propertyListing: [
    'Apartment/Flat',
    'Condo/Serviced Residence',
    'SOHO',
    'SOVO',
    'Semi-D/Bungalow',
    'Terrace/Link/Townhouse',
    'Residential Land',
    'Shop/Office/Retail Space',
    'Commercial Land',
    'Factory/Warehouse',
    'Industrial Land',
    'Agricultural Land',
  ],
  state: [
    'Selangor',
    'Kuala Lumpur',
    'Johor',
    'Penang',
    'Perak',
    'Negeri Sembilan',
    'Melaka',
    'Pahang',
    'Sabah',
    'Sarawak',
    'Kedah',
    'Putrajaya',
    'Kelantan',
    'Terengganu',
    'Perlis',
    'Labuan',
  ],
  categoryListing: ['Residential', 'Commercial'],
  rentCumReceiptClause1: ['The Landlord', 'The Tenant'],
  secureAgencyType: ['AD-HOC AGENCY', 'EXCLUSIVE AGENCY'],
  typeOfSales: ['Agent', 'Internal Cobroke', 'CoAgency'],
  purchaserAgentFeesType: [
    {label: 'RM', value: 'PurchaserCommission'},
    {label: 'Percentage', value: 'PurchaserCommissionGST'},
  ],
  purchaserRepresentBy: ['Purchaser', 'Vendor'],
  tenantRepresentBy: ['Tenant', 'Landlord'],
  claimsCategory: [
    {label: '1st claim', value: '1st claim'},
    {label: '2nd claim', value: '2nd claim'},
    {label: 'Final claim', value: 'Final claim'},
  ],
  claimsType: [
    {label: 'Developer Sales', value: 'DeveloperSales'},
    {label: 'Purchase', value: 'Purchase'},
    {label: 'Rent', value: 'Rent'},
  ],
  claimsTypeOfSales: [
    {label: 'Subsale', value: 'Subsale'},
    {label: 'Project', value: 'Project'},
  ],
  claimsTypeOfClaim: [
    {label: 'Commission', value: 'Commission'},
    {label: 'Cancelled Case', value: 'Cancelled'},
  ],
  claimsSalesBy: [
    {label: 'Agent', value: 'Agent'},
    {label: 'Internal Cobroke', value: 'Internal'},
    {label: 'Co Agency', value: 'CoAgency'},
  ],
  claimsGSTBy: [
    {label: 'Owner', value: 'Owner'},
    {label: 'Agent', value: 'Agent'},
  ],
  requesterType1: [
    {label: 'Purchaser', value: 'Purchaser'},
    {label: 'Vendor', value: 'Vendor'},
    {label: 'Co Agency', value: 'Co Agency'},
  ],
  requesterType2: [
    {label: 'Tenant', value: 'Tenant'},
    {label: 'Landlord', value: 'Landlord'},
    {label: 'Co Agency', value: 'Co Agency'},
  ],
  invoiceTaxByType: [
    {label: 'SST By Agent', value: 'SST By Agent'},
    {label: 'SST By Owner', value: 'SST By Owner'},
  ],
  formStatus: [
    {label: 'All', value: ''},
    {label: 'Pending', value: 'Pending'},
    {label: 'Cancelled', value: 'Cancelled'},
    {label: 'Completed', value: 'Completed'},
  ],
  marital: [
    {label: 'Select an option', value: ''},
    {label: 'Married', value: 'Married'},
    {label: 'Single', value: 'Single'},
  ],
  marital2: [
    {label: 'Married', value: 'Married'},
    {label: 'Single', value: 'Single'},
    {label: 'Divorced', value: 'Divorced'},
  ],
  sex: [
    {label: 'Select an option', value: ''},
    {label: 'Male', value: 'Male'},
    {label: 'Female', value: 'Female'},
  ],
  sourceOfFinance: [
    {label: 'Bank', value: 'Bank'},
    {label: 'Cash', value: 'Cash'},
    {label: 'Govt', value: 'Govt'},
    {label: 'Staff', value: 'Staff'},
  ],
  modeOfPayment: [
    {label: 'Cash', value: 'Cash'},
    {label: 'Cheque / Bankdraft', value: 'Cheque'},
    {label: 'Credit Card', value: 'Credit'},
    {label: 'Bank Transfer', value: 'Bank Transfer'},
  ],
  paymentMethod: [
    {label: 'Cheque No', value: 'Cheque No'},
    {label: 'Cash Deposit', value: 'Cash Deposit'},
    {label: 'Online Transfer', value: 'Online Transfer'},
  ],

  employmentPosition: [
    {label: 'Real Estate Negotiator', value: 'Real Estate Negotiator'},
    {label: 'Senior Negotiator', value: 'Senior Negotiator'},
    {label: 'Team Leader', value: 'Team Leader'},
    {label: 'Group Leader', value: 'Group Leader'},
    {label: 'Pre Leader', value: 'Pre Leader'},
  ],
  incomeTaxType: [
    {label: 'C', value: 'C'},
    {label: 'C1', value: 'C1'},
    {label: 'TN', value: 'TN'},
    {label: 'PT', value: 'PT'},
    {label: 'SG', value: 'SG'},
    {label: 'OG', value: 'OG'},
    {label: 'D', value: 'D'},
    {label: 'TP', value: 'TP'},
    {label: 'TJ', value: 'TJ'},
    {label: 'TF', value: 'TF'},
  ],
}
